import { render, staticRenderFns } from "./MyPagePoint.vue?vue&type=template&id=fd5e2086&scoped=true"
import script from "./MyPagePoint.vue?vue&type=script&lang=js"
export * from "./MyPagePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5e2086",
  null
  
)

export default component.exports